module.exports = __webpack_public_path__ + "img/ring_g_s_1_0@2x.a41e97e5.png";